import axiosInstance from "./AxiosInstance";

// Get
export function getMonthlyTargets(month,year) {
  return axiosInstance.post("setting/getMonthlyTargets", { month,year });
}

// Add / Update
export function addOrUpdateMonthlyTarget(payload) {
  return axiosInstance.post(
    "setting/addOrUpdateMonthlyTargets",
    payload
  );
}


// ✅ DELETE
export function deleteMonthlyTarget(target_id) {
  return axiosInstance.post(
    "setting/deleteMonthlyTarget",
    { target_id }
  );
}
